export const DEFAULT_MFR_NAME = 'My';
